<template>
    <component :is="template">
        <v-container>
            <v-row>
                <v-col>
                    <div class="contents-area">
                        <div class="contents-area__inner">
                            <div class="tit-wrap tit-wrap--unberline">
                                <v-row align="center">
                                    <v-col cols="12" md="">
                                        <v-row align="center" class="row--small">
                                            <v-col cols="auto">
                                                <v-btn icon text small @click="()=>$router.push('/gshop/brand')"><v-icon>mdi-arrow-left</v-icon></v-btn>
                                            </v-col>
                                            <v-col>
                                                <h2 class="tit">쿠폰 검색</h2>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" md="auto">
                                        <v-text-field v-model="filter.searchValue" name="search" type="search" autocomplete="off" hide-details outlined placeholder="쿠폰 검색" class="w-100 w-md-260px" @keydown.enter="page=1; search(true);">
                                            <template v-slot:append>
                                                <v-icon v-show="filter.searchValue" size="28" class="mr-1" @click="filter.searchValue = null">mdi-close</v-icon>
                                                <v-icon size="28" @click="page=1; search(true);">mdi-magnify</v-icon>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </div>

                            <!-- 쿠폰 리스트 -->
                            <giftcard-detail :giftcards="giftcards" :me="me"/>

                            <div class="mt-30px mt-md-70px">
                                <v-pagination v-model="page" :length="pageCount" color="primary" total-visible="11" @input="search(true)"/>
                            </div>

                        </div>
                    </div>
                </v-col>
            </v-row>
            <v-dialog v-model="dialog" max-width="500" :width="$vuetify.breakpoint ? '50%' : '90%' " scrollable>
                <v-card>
                    <a href="/mypage/profile"><v-img src="/images/giftcard-popup3.jpg"/></a>
                    <div class="popup-layer-foot" style="display: flex; background-color: #424242; padding: 10px;">
                        <v-spacer></v-spacer>
                        <v-btn text @click="close" style="color:white; font-size: 16px;">닫기</v-btn>
                    </div>
                </v-card>
            </v-dialog>
        </v-container>
    </component>
</template>

<script>
import api from '@/api'
import giftcardDetail from "@/components/client/gshop/giftcard/giftcard-detail.vue";

export default {
    components: { giftcardDetail },
    data() {
        return {
            me: null,
            meLoaded: true,

            giftcards: [],

            page: Number(this.$route.query.page) || 1,
            limit: 28,
            pageCount: 0,

            dialog: false,
            filter:{
                searchKey:  "name",
                searchValue: this.$route.query.search || null
            }
        };
    },
    mounted() {
        this.init();
    },
    created(){
        if(this.logoff) this.$router.push(`/login`);
    },
    methods: {
        async init() {
            let { me } = await  api.v1.me.profile.get();
            this.me = me;
            this.meLoaded = true;

            //API 랜더링 후 팝업 여부 결정
            if(!this.me?.ci && this.meLoaded) this.dialog = true;

            await this.search()
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { search: this.filter.searchValue, page: this.page }
                });
            }

            let { summary, giftcards } = await api.v1.gshop.giftcards.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: { ...this.filter }
            })
            this.giftcards = giftcards;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
        close(){
            this.dialog = false
        }
    },
    computed: {
        template() {
            return () => import(`@/templates/${this.$theme.pages.gshop}`);
        },
        accessToken(){
            return this.$store.state.accessToken;
        },
        logoff(){
            return !this.$store.state.accessToken;
        },
    },
    watch: {
        dialog(){
            if(!this.me.ci && !this.dialog){
                this.$router.push('/mypage/profile')
            }
        },
    }
};
</script>

<style lang="scss" scoped>
@media (min-width: 1024px) {
    .contents-area {
        padding: 60px 114px;
    }
}
</style>
